import { Paper, Separator } from '@carboncopyco/ui';
import { Children, type ReactElement, cloneElement } from 'react';
import {
  TableEmptyState,
  TableErrorState,
} from '../SessionBreakdownComponents';
import { StatsCardErrorOrEmpty } from './StatsCardErrorOrEmpty';
import { StatsCardGraph } from './StatsCardGraph';
import { StatsCardItem } from './StatsCardItem';

export type StatsCardProps = {
  children: ReactElement[];
  isError?: boolean;
  isEmpty?: boolean;
  title?: string;
};

export const StatsCard = ({
  isError,
  isEmpty,
  children,
  title,
}: StatsCardProps) => {
  return (
    <Paper
      radius
      border="ds-regular"
    >
      <div className="flex flex-col w-full h-full">
        {isError ? (
          <StatsCardErrorOrEmpty title={title}>
            <TableErrorState />
          </StatsCardErrorOrEmpty>
        ) : isEmpty ? (
          <StatsCardErrorOrEmpty title={title}>
            <TableEmptyState />
          </StatsCardErrorOrEmpty>
        ) : (
          Children.map(children, (child, index) => {
            if (index === Children.toArray(children).length - 1) {
              return cloneElement(child, { isLast: true });
            }
            return (
              <>
                {child}
                <Separator horizontal />
              </>
            );
          })
        )}
      </div>
    </Paper>
  );
};

StatsCard.Graph = StatsCardGraph;
StatsCard.Item = StatsCardItem;
